var _style, _defs, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 800 600",
    width: 800,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes spin2 {\n      0% {\n        stroke-dasharray: 100, 200;\n        stroke-dashoffset: 100px;\n      }\n      \n      20% {\n        stroke-dasharray: 50, 100;\n        stroke-dashoffset: -200px;\n      }\n      100% {\n        stroke-dasharray: 150, 150;\n        stroke-dashoffset: 0px;\n      }\n    }\n\n    .spin2 {\n      transform-origin: center;\n      animation: spin2 6.28s ease infinite,\n        spin 3.14s ease infinite;\n      animation-direction: alternate;\n      filter: url(#glow);\n    }\n\n    .spin3 {\n        transform-origin: center;\n        animation: 2.3s ease-in-out infinite,\n        spin 2.6s linear infinite;\n    }\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-40%",
    y: "-40%",
    width: "250%",
    height: "250%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "spin3",
    cx: 400,
    cy: 300,
    fill: "none",
    r: 100,
    strokeWidth: 12,
    stroke: "#404e65",
    strokeDasharray: "470 1400",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "spin2",
    cx: 400,
    cy: 300,
    fill: "none",
    r: 75,
    strokeWidth: 8,
    stroke: "#ced3d6",
    strokeDasharray: "1 1400",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.7155a9ad56b2ae33f6629ce58a1a892b.svg";
export { ForwardRef as ReactComponent };